import { useEffect, useState } from "react";
import TableHeading from "../../../Components/common/table/Tableheading";
import { showData } from "../../../Utils/APIs/commonShowAPI";
import NormalInput from "../../../Components/common/input/NormalInput";
import {commonInsertWithPost} from "../../../Utils/APIs/commonInsertWithPost";
const ApprovedMeterList = () => {
  const [list, setList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [consignmentId, setConsignmentId] = useState(null);
  const [selected, setSelected] = useState("");
  const [otherValue, setOtherValue] = useState("");
  const [remark, setRemark] = useState("");
  const heading = [
    "SR.no.",
    "Vehicle No.",
    "travel date",
    // "total travel days",
    "App Distance",
    "Map distance",
    "meter reading",
    "Starting Date",
    "End Date",
    "meter initial reading image",
    "meter final reading image",
    "Action",
  ];
  const fetchList = async () => {
    await showData("track/requestMeterUpdateList", setList);
  };
  useEffect(() => {
    fetchList();
  }, []);

  const handleSubmitUpdateMeterSubmit = async (status) => {
    const payload = {
      consignmentId,
      updateType: selected,
      newMeterReading: selected === "other" ? otherValue : null,
      remark,
      status
    };
    const response = await commonInsertWithPost("track/submitMeterUpdateAction", payload);
    console.log("submit response", response);
    if(response?.success){
      setIsOpen(false);
      fetchList();
      alert(response.message ||"Action submitted successfully");
    }else{
      alert(response?.message || "Error occurred" );   
    }
  }
  return (
    <div className="w-auto flex flex-col h-full overflow-auto p-4">
      <div className="mainHeading">
        <h1 className="text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50 rounded-lg">
          T<span className="text-lg">RANSPORT</span> M
          <span className="text-lg">ETER</span> U
          <span className="text-lg">PDATE</span> L
          <span className="text-lg">IST</span>
        </h1>
      </div>
      <table className="w-full mt-6 table-auto border-collapse border border-slate-400">
        <TableHeading list={heading} />
        <tbody>
          {list.length > 0 &&
            list.map((item, index) => (
              <tr
                key={index}
                className="text-center border border-slate-300 odd:bg-white even:bg-gray-100"
              >
                <td className="border border-slate-300 p-2">{index + 1}</td>
                <td className="border border-slate-300 p-2">
                  {item?.Vehicle?.[0]?.vehicleNumber || "N/A"}
                </td>
                <td className="border border-slate-300 p-2">
                  {item?.createdAt.split("T")[0]}
                </td>
                <td className="border border-slate-300 p-2">
                  {item?.PunchData[0]?.totalDistance}
                </td>
                <td className="border border-slate-300 p-2">
                  {item?.newMapReading || "N/A"}
                </td>
                <td className="border border-slate-300 p-2">
                  {item?.newMeterReading || "N/A"}
                </td>
                <td className="border border-slate-300 p-2">
                  {item?.PunchData[0]?.createdAt.split("T")[0] || "N/A"}
                </td>
                <td className="border border-slate-300 p-2">
                  {item?.PunchData[0]?.updatedAt.split("T")[0] || "N/A"}
                </td>
                <td className="border border-slate-300 p-2">
                  {item?.initialMeterImage ? (
                    <a
                      href={`${process.env.REACT_APP_API_URL}${item?.initialMeterImage}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={`${process.env.REACT_APP_API_URL}${item?.initialMeterImage}`}
                        alt="Initial Meter"
                        className="w-20 h-20 object-cover mx-auto"
                      />
                    </a>
                  ) : (
                    "N/A"
                  )}
                </td>
                <td className="border border-slate-300 p-2">
                  {item?.initialMeterImage ? (
                    <a
                      href={`${process.env.REACT_APP_API_URL}${item?.finalMeterImage}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={`${process.env.REACT_APP_API_URL}${item?.finalMeterImage}`}
                        alt="Initial Meter"
                        className="w-20 h-20 object-cover mx-auto"
                      />
                    </a>
                  ) : (
                    "N/A"
                  )}
                </td>
                <td className="border border-slate-300 p-2">
                  <button
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                    onClick={() => {
                      setConsignmentId(item?.consignmentId);
                      setIsOpen(true);
                    }}
                  >
                    Action
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg w-96 relative">
            {/* Close Icon */}
            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-3 right-3 text-gray-600 hover:text-black text-xl"
            >
              ×
            </button>

            <h2 className="text-xl font-semibold mb-4">Update Meter Reading</h2>

            {/* Radio Buttons */}
            <div className=" p-2 flex justify-evenly mb-4 border-2">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="updateType"
                  value="map"
                  checked={selected === "map"}
                  onChange={() => setSelected("map")}
                />
                Map
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="updateType"
                  value="meter"
                  checked={selected === "meter"}
                  onChange={() => setSelected("meter")}
                />
                Meter
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="updateType"
                  value="other"
                  checked={selected === "other"}
                  onChange={() => setSelected("other")}
                />
                Other
              </label>
            </div>

            {/* Other Input Field */}
            {selected === "other" && (
              <NormalInput 
                label="New Meter Reading"
                value={otherValue}
                setterFun={setOtherValue}
                isRequired={false}
                placeholder={"Enter new meter reading"}
                type="number"
              />
            )}
            <NormalInput 
                label="Remark"
                value={remark}
                setterFun={setRemark}
                isRequired={false}
                placeholder={"Write. . . . ."}
                type="text"
              />
            {/* Submit Button */}
            <button
              onClick={()=>handleSubmitUpdateMeterSubmit("Approved")}
              className="w-full mt-4 bg-blue-600 hover:bg-blue-700 text-white py-2 rounded"
            >
              Approved
            </button>
            <button
              onClick={()=> handleSubmitUpdateMeterSubmit("Rejected")}
              className="w-full mt-4 bg-red-600 hover:bg-red-700 text-white py-2 rounded"
            >
              Reject
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ApprovedMeterList;
